import { useQuery } from '@tanstack/react-query';

import { contractDocumentsQueryOptions } from '../data-provider';
import type { ContractDocumentsParams } from '../models';

export const useContractDocuments = (params: ContractDocumentsParams) =>
  useQuery(contractDocumentsQueryOptions(params));
